"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToTimeUnit = exports._CalculateAOV_V2 = exports._ParseAOV = exports.EMagiclinePriceAdjustmentTypes = void 0;
var EMagiclinePriceAdjustmentTypes;
(function (EMagiclinePriceAdjustmentTypes) {
    EMagiclinePriceAdjustmentTypes["AFTER_TIME"] = "AFTER_TIME";
    EMagiclinePriceAdjustmentTypes["AFTER_TERM"] = "AFTER_TERM";
})(EMagiclinePriceAdjustmentTypes || (exports.EMagiclinePriceAdjustmentTypes = EMagiclinePriceAdjustmentTypes = {}));
var DEBUG_AOV_CALC = localStorage.getItem('debug') === 'true';
var _ParseAOV = function (value) {
    if (!(value === null || value === void 0 ? void 0 : value.length)) {
        return undefined;
    }
    try {
        var parsed = JSON.parse(value);
        if (typeof parsed === 'object' &&
            parsed !== null &&
            typeof parsed.total === 'number' &&
            typeof parsed.fees === 'number' &&
            typeof parsed.subscription === 'number' &&
            typeof parsed.modules === 'number') {
            return parsed;
        }
    }
    catch (error) {
        console.warn('Invalid AOV value in localStorage', value, error);
    }
    return undefined;
};
exports._ParseAOV = _ParseAOV;
var _CalculateAOV_V2 = function (term, selectedOptionalModules, preview) {
    var _a, _b;
    if (selectedOptionalModules === void 0) { selectedOptionalModules = []; }
    var aov = { total: 0, fees: 0, subscription: 0, modules: 0 };
    // membership
    aov.subscription = calculateMembershipPrice(term, preview);
    // fees
    for (var _i = 0, _c = (_a = term.flatFees) !== null && _a !== void 0 ? _a : []; _i < _c.length; _i++) {
        var fee = _c[_i];
        var feePrice = getPreviewDiscountedPrice(fee, preview === null || preview === void 0 ? void 0 : preview.flatFeePreviews);
        if (fee.paymentFrequencyType === 'NON_RECURRING') {
            aov.fees += feePrice;
        }
        else if (fee.paymentFrequencyType === 'RECURRING' &&
            fee.paymentFrequencyValue &&
            term.termUnit === fee.paymentFrequencyUnit) {
            // assuming fees are paid in the same interval unit as the term and not paid in bonus period
            var numberOfRecurringPayments = (Number(term.termValueWithoutBonusPeriod) || 0) / fee.paymentFrequencyValue;
            aov.fees += feePrice * numberOfRecurringPayments;
        }
    }
    // modules
    for (var _d = 0, _e = (_b = term.optionalModules) !== null && _b !== void 0 ? _b : []; _d < _e.length; _d++) {
        var module_1 = _e[_d];
        if (selectedOptionalModules.includes(module_1.id)) {
            var modulePricePerPayment = getPreviewDiscountedPrice(module_1, preview === null || preview === void 0 ? void 0 : preview.selectedOptionalModulesPreviews);
            if (module_1.paymentFrequencyType === 'NON_RECURRING') {
                aov.modules += modulePricePerPayment;
            }
            else {
                var paymentsPerTermUnit = 1 / (0, exports.convertToTimeUnit)(module_1.paymentFrequencyValue, module_1.paymentFrequencyUnit, term.termUnit);
                var modulePrice = paymentsPerTermUnit * (Number(term.termValueWithoutBonusPeriod) || 0) * modulePricePerPayment;
                //console.log("Module", module.name, "was selected and will cost", modulePrice, "in total")
                aov.modules += modulePrice;
            }
        }
    }
    aov.total = aov.fees + aov.modules + aov.subscription;
    aov.total = applyPreviewCredit(aov.total, preview);
    console.log('AOV result', aov);
    return {
        total: Math.round(aov.total * 100) / 100,
        fees: Math.round(aov.fees * 100) / 100,
        modules: Math.round(aov.modules * 100) / 100,
        subscription: Math.round(aov.subscription * 100) / 100,
    };
};
exports._CalculateAOV_V2 = _CalculateAOV_V2;
var calculateMembershipPrice = function (term, preview) {
    var _a;
    if (((_a = term.priceAdjustmentRules) !== null && _a !== void 0 ? _a : []).length) {
        // have to sort them by time they are in effect, so we get "after 2 month, after 4 month", instead of "after 4 month, after 2 month"
        var sortedAdjustmentRules = sortPriceAdjustmentRules(term);
        for (var _i = 0, sortedAdjustmentRules_1 = sortedAdjustmentRules; _i < sortedAdjustmentRules_1.length; _i++) {
            var rule = sortedAdjustmentRules_1[_i];
            if (DEBUG_AOV_CALC)
                console.log('adjustment rule', convertPriceAdjustmentRules(rule, 0, term), 'with base', rule, 'and in days', adjustmentInDays(convertPriceAdjustmentRules(rule, 0, term)));
        }
        var paymentSchedule = getPaymentSchedule(term);
        var paymentUnit = paymentSchedule.paymentUnit;
        var totalPayments = paymentSchedule.totalPayments;
        if (DEBUG_AOV_CALC)
            console.log('contract is paid every', term.paymentFrequencyValue, term.paymentFrequencyUnit, 'for', term.termValue, term.termUnit, 'so total payments will be', totalPayments);
        var currentPaymentCount = 0;
        var currentMembershipPrice = Number(term.price) || 0; // not startPrice, which is 0 with bonus period!
        var totalMembershipPrice = 0;
        // for each adjustment, calculate how many payments are made before its in effect
        for (var _b = 0, sortedAdjustmentRules_2 = sortedAdjustmentRules; _b < sortedAdjustmentRules_2.length; _b++) {
            var adjustment = sortedAdjustmentRules_2[_b];
            if (currentPaymentCount >= totalPayments)
                continue;
            var rule = convertPriceAdjustmentRules(adjustment, currentMembershipPrice, term);
            if (!rule)
                continue;
            if (DEBUG_AOV_CALC)
                console.log('next rule is after', rule.adjustmentValue, rule.adjustmentUnit, 'of type', rule.adjustmentType, 'term has a payment frequency unit of', term.paymentFrequencyUnit);
            // ===== FIX: rule activates after TIME -> convert to payment units -> count actual debits before that time =====
            var changeTimeInPaymentUnits = (0, exports.convertToTimeUnit)(rule.adjustmentValue, rule.adjustmentUnit, paymentUnit);
            var ruleActiveAfterPaymentCount = Math.min(totalPayments, paymentSchedule.countPaymentsBefore(changeTimeInPaymentUnits));
            var priceForThisPhase = calculateMembershipPhasePrice(currentMembershipPrice, currentPaymentCount, ruleActiveAfterPaymentCount, paymentSchedule, preview, term);
            if (DEBUG_AOV_CALC)
                console.log('this rule is active after', ruleActiveAfterPaymentCount, 'payments, last phase was at', currentPaymentCount, 'payments, so this phase costs ', ruleActiveAfterPaymentCount - currentPaymentCount, 'times', currentMembershipPrice, 'for a total of ', priceForThisPhase);
            totalMembershipPrice += priceForThisPhase;
            currentMembershipPrice = rule.newPrice;
            currentPaymentCount = ruleActiveAfterPaymentCount;
        }
        // at the end add remaining payments for last adjustment ignoring end bonus period payments
        currentPaymentCount = Math.min(totalPayments, currentPaymentCount + paymentSchedule.paymentsSkippedAtEnd);
        if (DEBUG_AOV_CALC)
            console.log('last phase has', totalPayments - currentPaymentCount, 'payments left, with a price of', currentMembershipPrice);
        totalMembershipPrice += calculateMembershipPhasePrice(currentMembershipPrice, currentPaymentCount, totalPayments, paymentSchedule, preview, term);
        return totalMembershipPrice;
    }
    else {
        var paymentSchedule = getPaymentSchedule(term);
        if (DEBUG_AOV_CALC)
            console.log('Billable payments', paymentSchedule.billablePayments);
        return calculateMembershipPhasePrice(Number(term.price) || 0, 0, paymentSchedule.billablePayments, paymentSchedule, preview, term);
    }
};
var calculateMembershipPhasePrice = function (price, fromPaymentCount, toPaymentCount, paymentSchedule, preview, term) {
    var paymentCount = Math.max(0, toPaymentCount - fromPaymentCount);
    if (!paymentCount)
        return 0;
    var discountedPaymentCount = getDiscountedMembershipPaymentCount(paymentSchedule, preview, term);
    if (!discountedPaymentCount) {
        return paymentCount * price;
    }
    var discountedPaymentsInPhase = Math.max(0, Math.min(toPaymentCount, discountedPaymentCount) - fromPaymentCount);
    var regularPaymentsInPhase = paymentCount - discountedPaymentsInPhase;
    return regularPaymentsInPhase * price + discountedPaymentsInPhase * getDiscountedMembershipPrice(price, preview, term);
};
var getDiscountedMembershipPaymentCount = function (paymentSchedule, preview, term) {
    if (!preview || !hasMembershipDiscount(preview)) {
        return 0;
    }
    if (!preview.effectivePeriodTimeBasedTerm || !preview.effectivePeriodTimeBasedTermUnit) {
        return paymentSchedule.billablePayments;
    }
    var effectivePeriodInPaymentUnits = (0, exports.convertToTimeUnit)(Number(preview.effectivePeriodTimeBasedTerm) || 0, preview.effectivePeriodTimeBasedTermUnit, term.paymentFrequencyUnit);
    return Math.min(paymentSchedule.billablePayments, paymentSchedule.countPaymentsBefore(effectivePeriodInPaymentUnits));
};
var hasMembershipDiscount = function (preview) {
    return preview.discountedBasePrice !== undefined || !!preview.discountValue;
};
var getDiscountedMembershipPrice = function (price, preview, term) {
    var _a;
    if (preview.discountType === 'PERCENTAGE') {
        return Math.max(0, price * ((100 - ((_a = preview.discountValue) !== null && _a !== void 0 ? _a : 0)) / 100));
    }
    if (preview.discountValue !== undefined) {
        return Math.max(0, price - preview.discountValue);
    }
    if (preview.discountedBasePrice !== undefined) {
        var basePrice = Number(term.price) || 0;
        return Math.max(0, price - Math.max(0, basePrice - preview.discountedBasePrice));
    }
    return price;
};
var getPreviewDiscountedPrice = function (input, previews) {
    var discountedPreview = previews === null || previews === void 0 ? void 0 : previews.find(function (preview) { return preview.name === input.name && preview.discountedPrice !== null && preview.price !== preview.discountedPrice; });
    return (discountedPreview === null || discountedPreview === void 0 ? void 0 : discountedPreview.discountedPrice) !== null && (discountedPreview === null || discountedPreview === void 0 ? void 0 : discountedPreview.discountedPrice) !== undefined
        ? discountedPreview.discountedPrice
        : Number(input.price) || 0;
};
var applyPreviewCredit = function (total, preview) {
    var _a;
    return Math.max(0, total - ((_a = preview === null || preview === void 0 ? void 0 : preview.creditValue) !== null && _a !== void 0 ? _a : 0));
};
var getPaymentSchedule = function (term) {
    var _a;
    var fallbackCountPaymentsBefore = function () { return 0; };
    var paymentUnit = term === null || term === void 0 ? void 0 : term.paymentFrequencyUnit;
    var paymentInterval = Number(term === null || term === void 0 ? void 0 : term.paymentFrequencyValue) || 0;
    var termLengthInPaymentUnits = (0, exports.convertToTimeUnit)(Number(term === null || term === void 0 ? void 0 : term.termValue) || 0, term === null || term === void 0 ? void 0 : term.termUnit, paymentUnit);
    if (!paymentUnit || !paymentInterval || !termLengthInPaymentUnits) {
        return {
            paymentUnit: paymentUnit,
            totalPayments: 0,
            billablePayments: 0,
            paymentsSkippedAtEnd: 0,
            countPaymentsBefore: fallbackCountPaymentsBefore,
        };
    }
    var rateBonusPeriods = (_a = term === null || term === void 0 ? void 0 : term.rateBonusPeriods) !== null && _a !== void 0 ? _a : [];
    // start bonus shifts FIRST debit instead of subtracting fractional payments
    var startBonusPeriod = rateBonusPeriods.find(function (a) { return a.termStrategy === 'CONTRACT_START'; });
    var startOffsetInPaymentUnits = startBonusPeriod
        ? (0, exports.convertToTimeUnit)(Number(startBonusPeriod.termValue) || 0, startBonusPeriod.termUnit, paymentUnit)
        : 0;
    // number of debits with debitTime < tExclusive, considering start offset
    var countPaymentsBefore = function (tExclusiveInPaymentUnits) {
        var eps = 1e-9; // boundary exclusive
        var last = tExclusiveInPaymentUnits - eps;
        if (last < startOffsetInPaymentUnits)
            return 0;
        return Math.floor((last - startOffsetInPaymentUnits) / paymentInterval) + 1;
    };
    var totalPayments = countPaymentsBefore(termLengthInPaymentUnits);
    // end bonus: payments at the end are free -> compute how many payments fall into that end window
    var endBonusPeriod = rateBonusPeriods.find(function (a) { return a.termStrategy === 'END_OF_CURRENT_TERM'; });
    var paymentsSkippedAtEnd = 0;
    if (endBonusPeriod) {
        var endBonusInPaymentUnits = (0, exports.convertToTimeUnit)(Number(endBonusPeriod.termValue) || 0, endBonusPeriod.termUnit, paymentUnit);
        var paymentsBeforeFullEnd = countPaymentsBefore(termLengthInPaymentUnits);
        var paymentsBeforeBillableEnd = countPaymentsBefore(Math.max(0, termLengthInPaymentUnits - endBonusInPaymentUnits));
        paymentsSkippedAtEnd = Math.max(0, paymentsBeforeFullEnd - paymentsBeforeBillableEnd);
    }
    return {
        paymentUnit: paymentUnit,
        totalPayments: totalPayments,
        billablePayments: Math.max(0, totalPayments - paymentsSkippedAtEnd),
        paymentsSkippedAtEnd: paymentsSkippedAtEnd,
        countPaymentsBefore: countPaymentsBefore,
    };
};
/**
 * Converts X of a unit to Y of another unit
 * For example, 4 weeks to 0,9237 months
 * Or 2 months to 8,66 weeks
 * @param amount
 * @param base
 * @param targetUnit
 * @returns
 */
var convertToTimeUnit = function (amount, base, targetUnit) {
    var _a;
    if (!base || !targetUnit) {
        return 1;
    }
    var conversions = {
        DAY: {
            DAY: 1,
            WEEK: 1 / 7,
            MONTH: 1 / 30.4375,
            YEAR: 1 / 365,
        },
        WEEK: {
            DAY: 7,
            WEEK: 1,
            MONTH: 1 / 4.333334,
            YEAR: 1 / 52,
        },
        MONTH: {
            DAY: 30.4375,
            WEEK: 4.333334,
            MONTH: 1,
            YEAR: 1 / 12,
        },
        YEAR: {
            DAY: 365,
            WEEK: 52,
            MONTH: 12,
            YEAR: 1,
        },
    };
    // Handle special exceptions for month-to-week conversions
    if (base === 'MONTH' && targetUnit === 'WEEK') {
        var monthToWeekMap = {
            1: 4.333334,
            6: 26,
            12: 52,
            24: 108,
        };
        if (monthToWeekMap[amount]) {
            return monthToWeekMap[amount];
        }
    }
    // Convert using the general conversion rates
    var conversionRate = (_a = conversions[base]) === null || _a === void 0 ? void 0 : _a[targetUnit];
    if (!conversionRate) {
        return amount;
    }
    return amount * conversionRate;
};
exports.convertToTimeUnit = convertToTimeUnit;
var toUtcMidnight = function (d) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())); };
var diffDaysUtc = function (from, to) {
    var msPerDay = 24 * 60 * 60 * 1000;
    var a = toUtcMidnight(from).getTime();
    var b = toUtcMidnight(to).getTime();
    // ceil so "today" -> 0, tomorrow -> 1, past dates negative
    return Math.ceil((b - a) / msPerDay);
};
var convertPriceAdjustmentRules = function (priceAdjustment, basePrice, term) {
    var _a;
    var mapping = {
        woche: 'WEEK',
        wochen: 'WEEK',
        monat: 'MONTH',
        monate: 'MONTH',
        jahr: 'YEAR',
        jahre: 'YEAR',
        tag: 'DAY',
        tage: 'DAY',
    };
    var adjustmentValue;
    var adjustmentUnit;
    var adjustmentType = EMagiclinePriceAdjustmentTypes.AFTER_TIME;
    if (priceAdjustment.recurrenceFrequency === 'Einmalig zur Vertragsverlängerung' ||
        priceAdjustment.recurrenceFrequency === 'Ab Vertragsverlängerung') {
        adjustmentValue = term.termValueWithoutBonusPeriod;
        adjustmentUnit = term.termUnit;
        adjustmentType = EMagiclinePriceAdjustmentTypes.AFTER_TERM;
    }
    else if (priceAdjustment.recurrenceFrequency.startsWith('Am ')) {
        // e.g. "Am 01.01.2026"
        var raw = priceAdjustment.recurrenceFrequency.slice(3).trim();
        var m = raw.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
        if (!m) {
            console.error("Unrecognized date format in recurrence frequency: ".concat(raw));
            return undefined;
        }
        var dd = m[1], mm = m[2], yyyy = m[3];
        var changeDate = new Date(Date.UTC(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10)));
        var today = new Date();
        var days = diffDaysUtc(today, changeDate);
        adjustmentValue = days;
        adjustmentUnit = 'DAY';
        // keep AFTER_TIME
    }
    else if (priceAdjustment.recurrenceFrequency.startsWith('Alle ')) {
        // e.g. "Alle 24 Monate", "Alle 7 Wochen", "Alle 1 Jahr"
        var m = priceAdjustment.recurrenceFrequency.match(/^Alle\s+(\d+)\s+(woche|wochen|monat|monate|jahr|jahre|tag|tage)\b/i);
        if (!m) {
            console.error("Unrecognized \"Alle\" pattern: ".concat(priceAdjustment.recurrenceFrequency));
            return undefined;
        }
        var valueStr = m[1], unitStr = m[2];
        var unit = mapping[unitStr.toLowerCase()];
        if (!unit) {
            console.error("Unrecognized unit in \"Alle\": ".concat(unitStr));
            return undefined;
        }
        adjustmentValue = parseInt(valueStr, 10);
        adjustmentUnit = unit;
        // keep AFTER_TIME
    }
    else {
        var combinedRegex = /Nach (?:(\d+)|eine[r|m]) (woche|monat|jahr|tag)/i;
        var matches = priceAdjustment.recurrenceFrequency.match(combinedRegex);
        if (!matches) {
            console.error("Unrecognized recurrence frequency: ".concat(priceAdjustment.recurrenceFrequency));
            return undefined;
        }
        var value = matches[1], unit = matches[2];
        adjustmentValue = value ? parseInt(value, 10) : 1; // Default to 1 if "eine[r|m]" is matched
        adjustmentUnit = mapping[unit.toLowerCase()];
        if (DEBUG_AOV_CALC)
            console.log('Adjustment rule was mapped to unit', adjustmentUnit, 'from initial unit', unit, 'from text', priceAdjustment.recurrenceFrequency, 'and value', adjustmentValue, 'from base value', value);
        if (!adjustmentUnit) {
            console.error("Unrecognized unit in recurrence frequency: ".concat(unit), priceAdjustment);
            return undefined;
        }
    }
    var parsedValue = parseFloat(((_a = priceAdjustment.value.replace(',', '.').match(/\d+(\.\d{1,2})?/)) === null || _a === void 0 ? void 0 : _a[0]) || '0');
    if (Number.isNaN(parsedValue)) {
        console.error("Invalid price adjustment value: ".concat(priceAdjustment.value));
        return undefined;
    }
    var finalValue = parsedValue;
    switch (priceAdjustment.chargeAdjustmentType) {
        case 'RELATIVE':
            finalValue = (basePrice * parsedValue) / 100;
            break;
        case 'BASIC_AMOUNT':
            // Value remains the parsed value for BASIC_AMOUNT
            break;
        case 'ABSOLUTE':
            // Value remains the parsed value for BASIC_AMOUNT
            break;
    }
    switch (priceAdjustment.type) {
        case 'RAISE':
            finalValue = basePrice + finalValue;
            break;
        case 'REDUCTION':
            finalValue = basePrice - finalValue;
            break;
        case 'NEW_BASIC_AMOUNT':
            // keep final value as final value
            break;
    }
    return {
        newPrice: finalValue,
        adjustmentUnit: adjustmentUnit,
        adjustmentValue: adjustmentValue,
        adjustmentType: adjustmentType,
    };
};
// returns after how many days the adjustment takes place
function adjustmentInDays(adjustment) {
    if (!adjustment)
        return 99999; // never should take effect
    switch (adjustment.adjustmentUnit) {
        case 'DAY':
            return adjustment.adjustmentValue;
        case 'WEEK':
            return adjustment.adjustmentValue * 7;
        case 'MONTH':
            return adjustment.adjustmentValue * 30;
        case 'YEAR':
            return adjustment.adjustmentValue * 365;
    }
}
var sortPriceAdjustmentRules = function (term) {
    var _a;
    var initialAdjustmentRules = __spreadArray([], ((_a = term.priceAdjustmentRules) !== null && _a !== void 0 ? _a : []), true);
    var sortedRules = initialAdjustmentRules.sort(function (r1, r2) {
        var adjustment1 = convertPriceAdjustmentRules(r1, 0, // doesnt matter for sorting
        term);
        var adjustment2 = convertPriceAdjustmentRules(r2, 0, // doesnt matter for sorting
        term);
        var adj1 = adjustmentInDays(adjustment1);
        var adj2 = adjustmentInDays(adjustment2);
        return (adj1 || 0) - (adj2 || 0);
    });
    return sortedRules;
};
